import * as dataStore from './DataStore';
import { getTitleUi, getMainTitle } from "./TitleInfoSelector";

export function getMoreAboutThisTitle() {
    let retval = null;

    var json = dataStore.getJsonData();

    let linkToNovelist = json.FeatureContent.LinkToNoveList;

	if (linkToNovelist) {

        let novelistLink = linkToNovelist.LinkToNoveList;
        
        if(novelistLink)
        {
            retval = {
                href: novelistLink,
                displayText: getMainTitle(json),
                target: "_blank",
                srcId: getTitleUi(json),
                destId: getSiteFromLink(novelistLink)
            };
        }
    }

    return retval;
}

export function getSiteFromLink(novelistLink)
{
    let inputStr = novelistLink;
    let siteSelectorRegex = new RegExp("[\?|&]site=([A-Za-z\-]+)");

    let matches = inputStr.match(siteSelectorRegex);

    return matches ? matches[1] : "";
}


// WEBPACK FOOTER //
// ./src/data/MoreAboutThisTitleSelector.js